import React, {Component} from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import {List, Map} from "immutable";
import {Icon} from "@blueprintjs/core";
import Modal from "@atlaskit/modal-dialog/dist/esm/components/Modal";
import _ from "lodash";

// Components
import SalesDocuments from "./SaleDocuments";
import PurchasesDocuments from "./PurchaseDocuments";
import OtherDocuments from './OtherDocuments';
import CreateSerieDialog from "../../../components/dialogs/CreateSerieDialog";
import UpdateSerieDialog from "../../../components/dialogs/UpdateSerieDialog";

// Actions
import {
    getSeries,
    createSerie,
    updateSerie,
    deleteSerie,
    cleanSeries
} from "../../../actions/series";
import DeleteSerieDialog from "../../../components/dialogs/DeleteSerieDialog";


class DocumentsTabs extends Component {

    // Component lifecycle
    constructor(props) {
        super(props);

        this.props.getSeries({});

        this.state = {
            tabIndex: this.getSelectedIndex(),

            // Modal State
            canSubmit: false,
            modalIsOpen: false,
            modalType: null,
            modalData: Map({})
        };

        this.getSelectedIndex = this.getSelectedIndex.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }
    componentWillUnmount() {
        this.props.cleanSeries();
    }

    // Tab functions
    getSelectedIndex() {
        // Check if any child route is active. As last step, check if principal route is active to assign default tab index.
        switch (this.props.history.location.pathname) {
            case '/documentos/ventas':
                return 0;
            case '/documentos/compras':
                return 1;
            case '/documentos/otros':
                return 2;
            default:
                return 0;
        }
    }
    handleTabChange(index, lastIndex, event) {
        let route = '';

        switch (index) {
            case 0:
                route = '/documentos/ventas';
                break;
            case 1:
                route = '/documentos/compras';
                break;
            case 2:
                route = '/documentos/otros';
                break;
            default:
                break;
        }

        this.props.history.push(route);
        this.setState({
            tabIndex: this.getSelectedIndex()
        });
    }

    // Modal handlers
    onCanSubmit = (canSubmit) => {
        this.setState({
            canSubmit
        });
    };
    openModal = (modalType, modalData) => {
        let propName = '';
        if (modalData && modalData.get('docType') && modalData.get('serieId')) {
            _.split(modalData.get('docType'), '_')
                .map((docType, i) => propName = i > 0 ? propName + _.capitalize(docType): propName + docType);
            propName = propName + 'sSeries';
        }

        this.setState({
            modalType,
            modalIsOpen: true,
            modalData: modalData ? modalData.merge({ propName }) : Map({})
        });
    };
    closeModal = () => {
        this.setState({
            modalType: null,
            modalIsOpen: false,
            modalData: Map({}),
            canSubmit: false
        })
    };

    render() {
        const {tabIndex} = this.state;

        // Modal Area
        let modal = null;
        if (this.state.modalIsOpen) {
            let selectedSerie = Map({});
            switch (this.state.modalType) {
                case 'createSerieDialog':
                    modal = {
                        width: 'medium',
                        title: 'Crear numeración de documentos',
                        body: (
                            <CreateSerieDialog
                                onRef={ref => (this.child = ref)}
                                onCanSubmit={this.onCanSubmit}
                                onCloseModal={this.closeModal}
                                createSerie={this.props.createSerie}
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="accept"
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!this.state.canSubmit}
                                    onClick={ () => this.child.onCreateButtonClick() }
                                >
                                    {'Crear'}
                                </button>
                            </div>
                        )
                    };
                    break;
                case 'updateSerieDialog':
                    if (this.state.modalData.get('propName') && this.state.modalData.get('serieId')) {
                        selectedSerie = this.props[this.state.modalData.get('propName')]
                            .filter(serie => serie.get('_id') === this.state.modalData.get('serieId'))
                            .get(0);
                    }
                    modal = {
                        width: 'medium',
                        title: 'Editar numeración de documentos',
                        body: (
                            <UpdateSerieDialog
                                onRef={ref => (this.child = ref)}
                                onCanSubmit={this.onCanSubmit}
                                onCloseModal={this.closeModal}
                                serie={selectedSerie}
                                updateSerie={this.props.updateSerie}
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="accept"
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!this.state.canSubmit}
                                    onClick={ () => this.child.onSaveButtonClick() }
                                >
                                    {'Guardar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                case 'deleteSerieDialog':
                    if (this.state.modalData.get('propName') && this.state.modalData.get('serieId')) {
                        selectedSerie = this.props[this.state.modalData.get('propName')]
                            .filter(serie => serie.get('_id') === this.state.modalData.get('serieId'))
                            .get(0);
                    }
                    modal = {
                        width: 'medium',
                        title: 'Borrar numeración de documentos',
                        body: (
                            <DeleteSerieDialog
                                onRef={ref => (this.child = ref)}
                                onCanSubmit={this.onCanSubmit}
                                onCloseModal={this.closeModal}
                                serie={selectedSerie}
                                deleteSerie={this.props.deleteSerie}
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="delete"
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={ () => this.child.onDeleteButtonClick() }
                                >
                                    {'Borrar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-auto d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                Configuración
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>Documentos</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button className="btn btn-primary" onClick={ () => this.openModal('createSerieDialog') } >
                                <Icon icon="insert"/>Numeración de Documentos
                            </button>
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="tabs-container">
                                <Tabs
                                    selectedIndex={tabIndex}
                                    onSelect={this.handleTabChange}
                                    selectedTabPanelClassName="active show"
                                >
                                    <TabList className="nav nav-tabs">
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 0})}>Ventas</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 1})}>Compras</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 2})}>Otros</Link>
                                        </Tab>
                                    </TabList>
                                    <div className="tab-content">
                                        <TabPanel className="tab-pane">
                                            <SalesDocuments
                                                salesInvoicesSeries={this.props.salesInvoicesSeries}
                                                issuesSeries={this.props.issuesSeries}
                                                salesOrdersSeries={this.props.salesOrdersSeries}
                                                quotesSeries={this.props.quotesSeries}
                                                costBreakdownsSeries={this.props.costBreakdownsSeries}
                                                customersSeries={this.props.customersSeries}
                                                openModal={this.openModal}
                                            />
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            <PurchasesDocuments
                                                purchaseInvoicesSeries={this.props.purchaseInvoicesSeries}
                                                receiptsSeries={this.props.receiptsSeries}
                                                purchaseOrdersSeries={this.props.purchaseOrdersSeries}
                                                suppliersSeries={this.props.suppliersSeries}
                                                openModal={this.openModal}
                                            />
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            <OtherDocuments
                                                employeesSeries={this.props.employeesSeries}
                                                warehousesSeries={this.props.warehousesSeries}
                                                openModal={this.openModal}
                                            />
                                        </TabPanel>
                                    </div>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
                { this.state.modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    // Reducers
    const seriesReducer = state.series;

    // Serie
    let series = seriesReducer.get('payload') || List([]);

    // Filter series
    let salesInvoicesSeries = List([]);
    let issuesSeries = List([]);
    let salesOrdersSeries = List([]);
    let quotesSeries = List([]);
    let costBreakdownsSeries = List([]);
    let customersSeries = List([]);
    let purchaseInvoicesSeries = List([]);
    let receiptsSeries = List([]);
    let purchaseOrdersSeries = List([]);
    let suppliersSeries = List([]);
    let employeesSeries = List([]);
    let warehousesSeries = List([]);

    series.forEach(serie => {
        switch (serie.get('document_type')) {
            case 'sales_invoice':
                salesInvoicesSeries = salesInvoicesSeries.insert(salesInvoicesSeries.size, serie);
                break;
            case 'issue':
                issuesSeries = issuesSeries.insert(issuesSeries.size, serie);
                break;
            case 'sales_order':
                salesOrdersSeries = salesOrdersSeries.insert(salesOrdersSeries.size, serie);
                break;
            case 'quote':
                quotesSeries = quotesSeries.insert(quotesSeries.size, serie);
                break;
            case 'cost_breakdown':
                costBreakdownsSeries = costBreakdownsSeries.insert(costBreakdownsSeries.size, serie);
                break;
            case 'customer':
                customersSeries = customersSeries.insert(customersSeries.size, serie);
                break;
            case 'purchase_invoice':
                purchaseInvoicesSeries = purchaseInvoicesSeries.insert(purchaseInvoicesSeries.size, serie);
                break;
            case 'receipt':
                receiptsSeries = receiptsSeries.insert(receiptsSeries.size, serie);
                break;
            case 'purchase_order':
                purchaseOrdersSeries = purchaseOrdersSeries.insert(purchaseOrdersSeries.size, serie);
                break;
            case 'supplier':
                suppliersSeries = suppliersSeries.insert(suppliersSeries.size, serie);
                break;
            case 'employee':
                employeesSeries = employeesSeries.insert(employeesSeries.size, serie);
                break;
            case 'warehouse':
                warehousesSeries = warehousesSeries.insert(warehousesSeries.size, serie);
                break;
            default:
                break;
        }
    });

    return {
        salesInvoicesSeries,
        issuesSeries,
        salesOrdersSeries,
        quotesSeries,
        costBreakdownsSeries,
        customersSeries,
        purchaseInvoicesSeries,
        receiptsSeries,
        purchaseOrdersSeries,
        suppliersSeries,
        employeesSeries,
        warehousesSeries
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSeries: (query) => dispatch(getSeries(query)),
        createSerie: (serie) => dispatch(createSerie(serie)),
        updateSerie: (serieId, serie) => dispatch(updateSerie(serieId, serie)),
        deleteSerie: (serieId) => dispatch(deleteSerie(serieId)),
        cleanSeries: () => dispatch(cleanSeries())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentsTabs);



// WEBPACK FOOTER //
// ./src/containers/configuration/documents/DocumentsTabs.js